import { Link, Box } from "@mui/material";
import "./home.css";
import { saveAs } from "file-saver";
import { onButtonClick } from "./download";
export default function Home() {
  // const ButtonClick = () => {
  //   // window.location.href =
  //   //   "https://drive.google.com/u/0/uc?id=1sz41DUZj0qrHWskFS5tUz-EgVhnjiD1U&export=download";
  //   saveAs(
  //     "https://drive.google.com/u/0/uc?id=1sz41DUZj0qrHWskFS5tUz-EgVhnjiD1U&export=download"
  //   );
  // };
  return (
    <Box
      id="home"
      sx={{
        display: { lg: "flex" },
        boxSizing: "border-box",
        backgroundColor: "#0a192f",
        color: "white",
        marginTop: "10px",
        paddingTop: "30px",
      }}
    >
      <Box
        sx={{
          width: { lg: "50%", sm: "100%", xs: "100%" },
          display: "flex",
          flexDirection: "column",
          color: "white",
          justifyContent: "center",
          textAlign: "center",
          margin: "auto",
          boxSizing: "border-box",
          alignContent: "center",
          paddingTop: "50px",
        }}
      >
        <h1>Hi There!</h1>
        <h1 id="user-detail-name">
          I'M <span style={{ color: "#cd5ff8" }}>NITESH SINDHU</span>
        </h1>
        <p alignContent="center">
          <img
            src="https://readme-typing-svg.herokuapp.com?&font=IBM+Plex+Sans&color=abcdei&size=22&lines=Problem Solver!;I'm+a+Full-Stack+Web+Developer;I'm+a+Software+Engineer"
            alt="resume"
            style={{ margin: "auto", paddingLeft: "40px" }}
          />
        </p>
        <Link
          href="https://drive.google.com/file/d/1sz41DUZj0qrHWskFS5tUz-EgVhnjiD1U/view?usp=sharing"
          target="_blank"
          style={{ textDecoration: "none", color: "white" }}
        >
          <button
            data-aos="fade-left"
            className="btn"
            onClick={onButtonClick}
            id="resume-button-2"
          >
            Download CV
          </button>
        </Link>
        {/* <a href="../Resume/Nitesh_Sindhu.pdf" download> */}
      </Box>
      <Box className="img">
        <img
          src="./home.gif"
          style={{ height: "100%", width: "100%" }}
          alt="img"
          className="home-img"
        />
      </Box>
    </Box>
  );
}
